export function setSession(username: string, password: string) {
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('password', password);
}

export function removeSession() {
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('password');
}

export function getSession(): Promise<[string, string]> {
    return Promise.all(
        [
            sessionStorage.getItem('username'),
            sessionStorage.getItem('password'),
        ],
    ).then(([username, password]) => [username || 'default', password || 'default']);
}
